export const handleS3Download = (s3Url, baseUrl) => {
    if (!s3Url) {
      console.warn("No S3 URL found.");
      return;
    }
  
    const cleanedBaseUrl = baseUrl.replace('/api', '');
    const fullUrl = `${cleanedBaseUrl}/${s3Url}`;
    window.open(fullUrl, "_blank");
  };